import { render, staticRenderFns } from "./SvgIconAbrirPrazo.vue?vue&type=template&id=4e6d9f1e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports